"use client"

import { useState } from "react"
import AbacusDisplay from "./AbacusDisplay"

const NumberLearning5to8 = ({ onScore }) => {
  const [currentNumber, setCurrentNumber] = useState(5)
  const [selectedCount, setSelectedCount] = useState(null)

  const numberData = [
    { number: 5, animals: ["🐸", "🐸", "🐸", "🐸", "🐸"], name: "лягушки" },
    { number: 6, animals: ["🐞", "🐞", "🐞", "🐞", "🐞", "🐞"], name: "божьи коровки" },
    { number: 7, animals: ["🐕", "🐕", "🐕", "🐕", "🐕", "🐕", "🐕"], name: "собачки" },
    { number: 8, animals: ["🐓", "🐓", "🐓", "🐓", "🐓", "🐓", "🐓", "🐓"], name: "петушки" },
  ]

  const current = numberData[currentNumber - 5]

  const checkAnswer = () => {
    if (selectedCount === currentNumber) {
      onScore(15)
      if (currentNumber < 8) {
        setCurrentNumber(currentNumber + 1)
        setSelectedCount(null)
      }
    }
  }

  return (
    <div className="lesson-card card-purple">
      <h2 className="lesson-title" style={{ color: "#7c2d12" }}>
        Изучаем цифры 5-8 📝
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "24px",
          marginBottom: "24px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Считаем {current.name}</h3>
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px solid #3b82f6",
            }}
          >
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "8px" }}>
              {current.animals.map((animal, index) => (
                <div key={index} style={{ fontSize: "1.875rem" }}>
                  {animal}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Цифра</h3>
          <div
            style={{
              fontSize: "5rem",
              fontWeight: "bold",
              color: "#9333ea",
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px solid #e5e7eb",
            }}
          >
            {currentNumber}
          </div>
          <div style={{ marginTop: "16px", color: "#6b7280", fontSize: "1.125rem" }}>Обведи цифру пальчиком ↗️</div>
        </div>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Абакус</h3>
          <AbacusDisplay value={currentNumber} />
        </div>
      </div>

      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <p style={{ fontSize: "1.25rem", marginBottom: "16px" }}>Сколько {current.name} ты видишь?</p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
            maxWidth: "400px",
            margin: "0 auto",
          }}
        >
          {[5, 6, 7, 8].map((num) => (
            <button
              key={num}
              onClick={() => setSelectedCount(num)}
              style={{
                fontSize: "1.5rem",
                padding: "24px",
                borderRadius: "50%",
                border: "2px solid",
                backgroundColor: selectedCount === num ? "#9333ea" : "white",
                color: selectedCount === num ? "white" : "#374151",
                borderColor: selectedCount === num ? "#7c3aed" : "#e5e7eb",
                cursor: "pointer",
              }}
            >
              {num}
            </button>
          ))}
        </div>
      </div>

      <div style={{ textAlign: "center" }}>
        <button
          onClick={checkAnswer}
          disabled={selectedCount === null}
          className="nav-button primary"
          style={{ opacity: selectedCount === null ? 0.5 : 1, backgroundColor: "#9333ea" }}
        >
          Проверить! ✨
        </button>
      </div>
    </div>
  )
}

export default NumberLearning5to8
